import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { STORE_NAMES } from '../../constants/store.constants';
import {
  ShowSystemErrorModal,
  UpdateFavoriteClinician,
  UpdateSelectedClinician,
  UpdateFilterResetOnToggle,
  SetActiveFilters
} from '../../store/actions/ClinicianListAction';
import info from '../../assets/images/info.svg';
import Image from '../Image/Image';
import { getFavoriteList } from '../../service/favorite.service';
import DialogBox from '../DialogBox/DialogBox';
import translations from '../../translations';

const Toggle = ({ setFavoriteData, setLoaderScroll, fetchClinicianList }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [savedActiveFilters, setSavedActiveFilters] = useState(null);
  const { pageConfig, activeFilters } = useSelector(state => state?.[STORE_NAMES.CLINICIAN_DIRECTORY_CLINICIANLIST]);
  const { isFavoriteToggle } = useSelector(state => state?.[STORE_NAMES.CLINICIAN_DIRECTORY_CLINICIANLIST]);
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(UpdateFavoriteClinician(false));
    };
  }, [dispatch]);

  const onClose = () => {
    setIsModalOpen(false);
  };

  const handleToggleFavorite = async e => {
    // Capture the checked value immediately to avoid React event pooling issues
    const isChecked = e.target.checked;
    const { region } = pageConfig;
    const param = {
      region: region,
      limit: 200,
      offset: 0,
      orderBy: 'lastName',
      order: 'ASC'
    };
    dispatch(UpdateFilterResetOnToggle(isChecked));
    if (isChecked) {
      // Save ONLY non-default region chiclets before turning on favorite
      if (activeFilters?.chiclets) {
        const regionChiclets = activeFilters.chiclets.filter(chiclet => chiclet.type === 'region' && chiclet.value !== pageConfig?.region);
        if (regionChiclets.length > 0) {
          // Save only the non-default region chiclets
          const savedRegionFilters = {
            ...activeFilters,
            chiclets: regionChiclets
          };
          setSavedActiveFilters(savedRegionFilters);
        } else {
          setSavedActiveFilters(null);
        }
      } else {
        setSavedActiveFilters(null);
      }
      // Clear active filters (red icon and chiclets) when favorite toggle is ON
      dispatch(SetActiveFilters(null));
      setLoaderScroll(true);
      const response = await getFavoriteList(param);
      setLoaderScroll(false);

      if (response?.error) {
        dispatch(ShowSystemErrorModal(true));
        return;
      }

      // Handle both array and object response formats
      const data = Array.isArray(response) ? response : response && response.data ? response.data : [];
      setFavoriteData(data);
      if (Array.isArray(data) && data.length > 0) {
        dispatch(UpdateFavoriteClinician(isChecked));
        setIsModalOpen(false);
      } else {
        setIsModalOpen(true);
      }
    } else {
      setFavoriteData([]);
      // Restore previous chiclets and red icon when toggle is turned OFF
      if (savedActiveFilters) {
        dispatch(SetActiveFilters(savedActiveFilters));
      } else {
        dispatch(SetActiveFilters(null));
      }
      dispatch(UpdateFavoriteClinician(isChecked));
      fetchClinicianList();
    }
    dispatch(UpdateSelectedClinician(null));
  };
  return (
    <div className={`vve-toggle-container${isFavoriteToggle ? ' vve-toggle-active' : ''}`}>
      {isFavoriteToggle && (
        <div className="vve-partition">
          <Image className="vve-img-Vertical" src={info} role="img" alt="info.svg" />
          {translations.FAVORITE_SEARCH_FILTER_DISABLE_TEXT}
        </div>
      )}
      <div className="vve-fav-div" data-testid="vve-toggle-component">
        <span className="vve-fav-label">{translations.FAVORITE}</span>

        <label className="vve-switch" aria-label={translations.FAVORITE}>
          <input type="checkbox" checked={isFavoriteToggle} onChange={handleToggleFavorite} />
          <span className="vve-slider vve-round"></span>
        </label>
      </div>
      {isModalOpen && (
        <DialogBox
          classes={{
            modalRoot: 'vve-nofav-modal'
          }}
          showModal={isModalOpen}
          modalTitle={translations.NO_FAVORITE_TITLE}
          modalBody={translations.No_FAVORITE_BODY}
          onClose={onClose}
        />
      )}
    </div>
  );
};

Toggle.propTypes = {
  setFavoriteData: PropTypes.func.isRequired,
  setLoaderScroll: PropTypes.func.isRequired,
  fetchClinicianList: PropTypes.func.isRequired
};

export default Toggle;
